<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px" [ngClass]="{ preview: isPreview }" class="table-margin">
  <div [fxFlex]="data?.length! > 0 && !isPreview ? '50' : '100'" fxFlex.lt-lg="100">
    <nz-layout>
      <nz-header class="table-header">
        <!--  -->
        @if (isEOC() || isInpatientView() || isPreview || (data?.length! > 0 || isLoading)) {
          <div
            class="table-header-row margin-lr">
            <div class="table-header-cell">
              {{ "Imaging Files" | translate }}
            </div>
            <!--  -->
            <div class="table-header-cell margin-lrr" *hasAddPermissions="['a-imgf']">
              @if (
                (isEOC() || isInpatientView()) &&
                !isPreview
                ) {
                <button nz-button nzShape="round" (click)="openModal()">
                  <div fxLayout="row">
                    <div fxLayout="col">
                      <mat-icon class="add-icon">add_circle_outline</mat-icon>
                    </div>
                    <div fxLayout="col" class="add-title">
                      {{ "Add" | translate }} {{ "Imaging" | translate }}
                    </div>
                  </div>
                </button>
              }
            </div>
          </div>
        }

        @if (!(isEOC() || isInpatientView()) && !isPreview && !(data?.length! > 0)) {
          <div fxLayout="row" class="table-header-row"
            >
            @if (!isLoading) {
              <div fxLayout="col" class="title">
                {{ "Imaging" | translate }} - {{ "No data available" | translate }}
              </div>
            }
          </div>
        }
      </nz-header>

      @if (data?.length! > 0 || isLoading) {
        <nz-content>
          <nz-table #nzTable nzTableLayout="fixed" nzShowTitle="false" nzSize="middle" nzNoResult="No Imaging data found"
            [nzLoading]="isLoading" [nzData]="data || []" [nzShowPagination]="pagination" [nzShowSizeChanger]="pagination"
            nzPaginationType="default" [nzFrontPagination]="pagination" [nzPageIndex]="currentPageIndex"
            (nzPageIndexChange)="handlePageIndexChange($event)" (nzPageSizeChange)="handlePageSizeChange($event)"
            [nzPageSizeOptions]="[5, 10, 20]" [nzPageSize]="pageSize">
            <thead>
              <tr>
                @for (
                  col of [
                  'Category',
                  'Modality',
                  'Date',
                  'Description',
                  'Exam Title'
                  ]
                  ; track
                  col) {
                  <th>
                    {{ col | translate }}
                    <app-tooltip [fieldName]="col" area="Imaging" />
                  </th>
                }
                @if (hasUnsubmitted() && !isPreview) {
                  <th nzWidth="70px">
                    {{ "Actions" | translate }}
                    <app-tooltip fieldName="Actions" area="Imaging" />
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of getData(); track item) {
                <tr
                  [ngClass]="{'draft-entry': !item?.['isSubmitted'] && (isEOC()||isInpatientView()), 'selected-preview': fileItem?.id === item.id }"
                  (click)="this.reportFiles = true; preview(item)">
                  @for (
                    field of [
                    'category',
                    'modality',
                    'date',
                    'description',
                    'examTitle'
                    ]
                    ; track
                    field) {
                    <td>{{ getValue(field, item[field]?.toString()) }}</td>
                  }
                  @if (
                    (isEOC() || isInpatientView()) &&
                    !item['isSubmitted'] &&
                    !isPreview
                    ) {
                    <td>
                      <i nz-icon nzType="icons:delete" nzTheme="outline" class="delete-btn"
                      (click)="deleteFun(item?.id!); $event.stopPropagation()"></i>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </nz-table>
        </nz-content>
      }
    </nz-layout>
  </div>

  @if (data?.length! > 0 && !isPreview) {
    <div [fxFlex]="50" fxFlex.lt-lg="100">
      <div class="document-view">
        <div class="preview-title">
          {{ "Preview" | translate }}
          {{ fileItem?.examTitle ? " - " + fileItem?.examTitle : ""
          }}@if (fileObj && !isPreviewLoading) {
          <span nz-icon nzType="icons:download" nzTheme="outline"
          class="download-btn" (click)="downloadPDF()"></span>
        }
      </div>
      @if (fileItem) {
        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="preview-buttons">
          <div fxLayout="column">
            <button nz-button [ngClass]="reportFiles ? 'active-btn' : 'inactive-btn'"
              (click)="reportFiles = true; preview()">
              {{ "Report" | translate }}
            </button>
          </div>
          <div fxLayout="column">
            <button nz-button [ngClass]="reportFiles ? 'inactive-btn' : 'active-btn'"
              (click)="reportFiles = false; preview()">
              {{ "Files" | translate }}
            </button>
          </div>
        </div>
      }
      <div class="preview-content" fxLayout="column" fxLayoutAlign="center center">
        @if (!isLoading && !isPreviewLoading) {
          <div class="file-name">
            {{ this.fileName }}
          </div>
        }
        @if (!fileObj && !isPreviewLoading) {
          <div>
            <i nz-icon nzType="icons:folder-view" nzTheme="outline" class="folder-view-icon"></i>
            <div>
              {{ "Select Imaging record to preview the file!" | translate }}
            </div>
          </div>
        }
        @if (isPreviewLoading) {
          <div><nz-spin nzSimple></nz-spin></div>
        }
        @if (fileObj && !isPreviewLoading && fileType == 'application/pdf') {
          <pdf-viewer class="pdf-viewer"
          [src]="fileObj" [render-text]="true" [original-size]="false" (click)="isVisible = true"></pdf-viewer>
        }
        @if (fileObj && !isPreviewLoading && fileType?.startsWith('image')) {
          <img nz-image [nzSrc]="fileObj"
            nzWidth="auto" nzHeight="auto" class="image-viewer" />
        }
      </div>
      @if (paginatorSize > 1 && !reportFiles) {
        <div class="file-paginator" fxLayout="column"
          fxLayoutAlign="center center">
          <nz-pagination [nzPageIndex]="1" [nzTotal]="paginatorSize" (nzPageIndexChange)="pageChange($event)"
          [nzPageSize]="1" nzSimple></nz-pagination>
        </div>
      }
    </div>
  </div>
}
</div>


<nz-modal #modalRef nzSize [(nzVisible)]="isVisible" [nzTitle]="('Preview' | translate) +
    (fileItem?.examTitle ? ' - ' + fileItem?.examTitle : '')" (nzOnCancel)="handleCancel()" nzCancelText="Cancel"
  nzOkText="Save" nzOkType="primary" [nzFooter]="null" class="custom-modal-class">
  <ng-container *nzModalContent>
    <pdf-viewer class="modal-pdf" [src]="fileObj" [render-text]="true" [original-size]="false"></pdf-viewer>
  </ng-container>
</nz-modal>

<div *ngComponentOutlet="addComp"></div>